module.exports = __webpack_public_path__ + "img/image_2.c4936cd3.svg";